import { put, takeLatest, call } from "redux-saga/effects";
import {
  addAddress,
  addNewAddressToUser,
  assignRoom,
  createNewRoom,
  fetchReceiverAddressInfo,
  fetchRevealInfo,
  getAssignedUsedDetails,
  getRoomInfo,
  getUserAddress,
  joinRoom,
} from "../../../api/secretSantaApi";
import {
  responseToJoinRoom,
  requestToAssignRoom,
  requestToCreateRoom,
  requestToFetchRoomInfo,
  requestToJoinRoom,
  requestToSaveAddress,
  responseToCreateRoom,
  responseToFetchRoomInfo,
  responseToSaveAddress,
  requestToFetchUserAddress,
  responseToFetchUserAddress,
  requestToFetchAssignedUserDetails,
  responseToFetchAssignedUserDetails,
  requestToAddNewAddressToUser,
  requestToFailedJoinRoom,
  responseFromAddNewAddressToUser,
  responseFromAssignRoom,
  requestToRevealSantaInfo,
  responseFromRevealSantaInfo,
} from "../../slices/secretSantaSlice";

/** */
function* createRoomSaga(action) {
  try {
    if (action?.payload) {
      const response = yield call(createNewRoom, action.payload); // actual API call [web:62][web:76]
      if (response?.success) {
        yield put(responseToCreateRoom());
      }

      //   yield put(
      //     responseFromFetchDeliveryDateAction({
      //       deliveryDates: response?.data, // adjust to real shape
      //     }),
      //   );
    }
  } catch (error) {
    console.log(error);
    // yield put(failedToFetchDeliveryDateAction(error));
  }
}
/** */
function* addAddressSaga(action) {
  try {
    if (action?.payload) {
      const response = yield call(addAddress, action.payload.addressData); // actual API call [web:62][web:76]
      if (response?.success || response?.error) {
        yield put(responseToSaveAddress(true));
        if (action.payload.type === "createRoom") {
          yield put(requestToCreateRoom({ ...action.payload.roomData }));
        }
        if (action.payload.type === "joinRoom") {
          yield put(requestToJoinRoom({ ...action.payload.joinRoomData }));
        }
      }
    }
  } catch (error) {
    console.log(error);
    // yield put(failedToFetchDeliveryDateAction(error));
  }
}

/** */
function* joinRoomSaga(action) {
  try {
    if (action?.payload) {
      const response = yield call(joinRoom, action.payload);
      if (response.success) {
        yield put(responseToJoinRoom());
      } else {
        yield put(requestToFailedJoinRoom(response?.data?.error));
      }
    }
  } catch (error) {
    console.log(error);
  }
}
/** */
function* fetchUserRoomInfoSage(action) {
  try {
    if (action?.payload) {
      const response = yield getRoomInfo(action.payload);
      yield put(responseToFetchRoomInfo(response));
    }
  } catch (error) {
    console.log(error);
  }
}
/** */
function* assigningRoomSaga(action) {
  try {
    if (action?.payload) {
      const response = yield call(assignRoom, action.payload);
      if (response) {
        yield put(responseFromAssignRoom());
      }
    }
  } catch (error) {
    console.log(error);
  }
}
/** */
function* getUserAddressSaga(action) {
  try {
    if (action?.payload) {
      const response = yield getUserAddress(action.payload);
      if (response?.hasAddress) {
        yield put(responseToFetchUserAddress());
      }
    }
  } catch (error) {
    console.log(error);
  }
}
/** */
function* getAssignedUserDetails(action) {
  try {
    if (action?.payload) {
      const response = yield getAssignedUsedDetails(action?.payload?.roomId, action?.payload?.userLoginId);
      if (response) {
        yield put(responseToFetchAssignedUserDetails(response));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

/** */
function* addingNewAddressToUserSaga(action) {
  try {
    const { formData, roomId, userId } = action.payload || {};
    if (formData && roomId && userId) {
      const addressResponse = yield fetchReceiverAddressInfo(roomId, userId);
      if (addressResponse?.canStartGifting) {
        const response = yield call(addNewAddressToUser, formData);
        if (response?.isSuccess) {
          yield put(responseFromAddNewAddressToUser());
        }
      } else {
        yield put(responseFromAddNewAddressToUser());
      }
    }
  } catch (error) {
    console.log(error);
  }
}

/** */
function* fetchSantaRevealInfo(action) {
  try {
    const { roomId, userId } = action.payload || {};
    if (roomId && userId) {
      const response = yield fetchRevealInfo(roomId, userId);
      yield put(responseFromRevealSantaInfo(response));
    }
  } catch (error) {
    console.log(error);
  }
}

/** */
export function* watcherSecretSanta() {
  yield takeLatest(requestToCreateRoom.type, createRoomSaga);
  yield takeLatest(requestToSaveAddress.type, addAddressSaga);
  yield takeLatest(requestToJoinRoom.type, joinRoomSaga);
  yield takeLatest(requestToFetchRoomInfo.type, fetchUserRoomInfoSage);
  yield takeLatest(requestToAssignRoom.type, assigningRoomSaga);
  yield takeLatest(requestToFetchUserAddress.type, getUserAddressSaga);
  yield takeLatest(requestToFetchAssignedUserDetails.type, getAssignedUserDetails);
  yield takeLatest(requestToAddNewAddressToUser.type, addingNewAddressToUserSaga);
  yield takeLatest(requestToRevealSantaInfo.type, fetchSantaRevealInfo);
}
